import React from 'react';


import { Formik } from 'formik';
import Yup from 'yup';
import {Input, SubmitButton, RGForm} from 'views/FormElements';

import UserAPI from 'service/api/UserAPI';

const Form = ({isSubmitting}) => {
	let submitBtn = "Forgot Password";
		
	if(isSubmitting === true)
		submitBtn = <span>Forgot Password <i className="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i></span>;

	return <RGForm>
		<Input name="email" type="text" label="Email: " style={{marginBottom: "0px"}} />

		<SubmitButton style={{marginTop: "10px"}} color="primary" disabled={isSubmitting}>
			{submitBtn}
		</SubmitButton>
	</RGForm>
};


class ForgotPassword extends React.Component {

	constructor(props) {
		super(props);
		
		this.INIT_VALUES = {email: ''};
		this.handleSubmission = this.handleSubmission.bind(this);
	}

	validationScheme() {
		return Yup.object().shape({
		    email: Yup.string().email('Email address is invalid').required('Email is required!'),
		});
	}

	handleSubmission(values, {setSubmitting}) {
		UserAPI.sendForgetPasswordEmail(values.email, function(success) {
			setSubmitting(false);
		});
	}

	render() {
		return <Formik initialValues={this.INIT_VALUES} onSubmit={this.handleSubmission}
						validationSchema={this.validationScheme} component={Form} />
	}
}

export default ForgotPassword;


// WEBPACK FOOTER //
// ./src/views/user/ForgotPassword.js